<template>
    <v-card>
        <v-card-title class="justify-center text-h5">
            <strong>{{ $t('Ganancias graficos') }}</strong>
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="12" sm="6">
                    <v-select
                        :label="$t('Tiempo')"
                        outlined
                        dense
                        :items="itemsTimes"
                        item-text="name"
                        item-value="val"
                        v-model="filterTime"
                        @change="getData"
                        :disabled="loading"
                    ></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                    <!-- <v-select
                        label="Analizar"
                        outlined
                        dense
                        :items="itemsAnalysis"
                        item-text="name"
                        item-value="val"
                        v-model="filterAnalysis"
                    ></v-select> -->
                </v-col>
                <v-col cols="12" sm="6" v-if="filterTime=='custom'">
                    <v-menu
                        v-model="menu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="dateInit"
                                :label="$t('Fecha inicial')"
                                prepend-icon="mdi-calendar"
                                readonly
                                outlined
                                dense
                                color="orange"
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="dateInit"
                            @input="menu1 = false, getData()"
                            locale="es"
                            color="primary"
                            class="ma-0"
                        ></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" sm="6" v-if="filterTime=='custom'">
                    <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="dateEnd"
                                :label="$t('Fecha final')"
                                prepend-icon="mdi-calendar"
                                readonly
                                outlined
                                dense
                                color="orange"
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="dateEnd"
                            @input="menu2 = false, getData()"
                            locale="es"
                            color="primary"
                            class="ma-0"
                        ></v-date-picker>
                    </v-menu>
                </v-col>
            </v-row>

            <v-divider/>

            <div class="text-h6 mb-1 mt-4 text-center">{{ $t('VENTAS') }}</div>
            <line-chart2 v-if="!loading" :data="[+dataResult['sales-physical'], +dataResult['sales-virtual'], +(dataResult['sales-physical']+dataResult['sales-virtual'])]" :labels="['Tienda fisica', 'Tienda virtual', 'Tienda fisica + virtual']" style="height: 300px" />
            <div v-else style="height: 200px;">
                <v-row
                    class="fill-height"
                    align-content="center"
                    justify="center"
                >
                    <v-col
                        class="text-subtitle-1 text-center"
                        cols="12"
                    >
                        {{ $t('Recopilando datos...') }}
                    </v-col>
                    <v-col cols="6">
                        <v-progress-linear
                            color="primary"
                            indeterminate
                            rounded
                            height="6"
                        ></v-progress-linear>
                    </v-col>
                </v-row>
            </div>

            <div class="text-h6 mb-1 mt-4 text-center">{{ $t('COSTOS DE VENTAS') }}</div>
            <line-chart2 v-if="!loading" :data="[+dataResult['costs-physical'], +dataResult['costs-virtual'], +(dataResult['costs-physical']+dataResult['costs-virtual'])]" :labels="['Tienda fisica', 'Tienda virtual', 'Tienda fisica + virtual']" style="height: 300px" />
            <div v-else style="height: 200px;">
                <v-row
                    class="fill-height"
                    align-content="center"
                    justify="center"
                >
                    <v-col
                        class="text-subtitle-1 text-center"
                        cols="12"
                    >
                        {{ $t('Recopilando datos...') }}
                    </v-col>
                    <v-col cols="6">
                        <v-progress-linear
                            color="primary"
                            indeterminate
                            rounded
                            height="6"
                        ></v-progress-linear>
                    </v-col>
                </v-row>
            </div>

            <div class="text-h6 mb-1 mt-4 text-center">{{ $t('GASTOS FIJOS') }}</div>
            <line-chart2 v-if="!loading" :data="showExpense?Object.keys(this.dataExpenses).map(e => this.dataExpenses[e].map(e => e.value).reduce((a, b) => a + b)):[]" :labels="showExpense?Object.keys(this.dataExpenses).map(e => e):[]" style="height: 300px" />
            <div v-else style="height: 200px;">
                <v-row
                    class="fill-height"
                    align-content="center"
                    justify="center"
                >
                    <v-col
                        class="text-subtitle-1 text-center"
                        cols="12"
                    >
                        {{ $t('Recopilando datos...') }}
                    </v-col>
                    <v-col cols="6">
                        <v-progress-linear
                            color="primary"
                            indeterminate
                            rounded
                            height="6"
                        ></v-progress-linear>
                    </v-col>
                </v-row>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            itemsTimes: [
                {val: 'day', name: 'Día actual'},
                {val: 'week', name: 'Semana actual'},
                {val: 'month', name: 'Mes actual'},
                {val: 'year', name: 'Año actual'},
                {val: 'custom', name: 'Personalizado'},
            ],
            filterTime: 'month',
            itemsAnalysis:[
                {val: 'physical', name: 'Tienda física'},
                {val: 'virtual', name: 'Tienda virtual'},
                {val: 'both', name: 'Tienda virtual + fisica'},
            ],
            filterAnalysis: 'both',
            menu1: false,
            menu2: false,
            dateInit: '',
            dateEnd: '',
            // results
            dataResult: {},
            showExpense: false,
            dataExpenses: null
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        async getData() {
            this.loading = true
            await axios.post('/admin/get-profits-results', {
                filterTime: this.filterTime,
                filterAnalysis: this.filterAnalysis,
                dateInit: this.dateInit,
                dateEnd: this.dateEnd
            })
            .then((response) => {
                // console.log(response);
                this.dataResult = response.data;
                this.dataExpenses = response.data['expenses'];
                if (Object.keys(this.dataExpenses).length > 0) {
                    this.showExpense = true
                }

                setTimeout(() => {
                    this.loading = false
                }, 100);
            })
            .catch((error) => {
                // console.log(error);
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }

                this.loading = false
            })
        }
    }
}
</script>
